/* GENERATED from pdp-cardinal.src.js by build/gen_js.py - do not edit.
   The commented source is pdp-cardinal.src.js. */
(function () {
'use strict';
var $ = function (s, r) { return (r || document).querySelector(s); };
var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
var money = function (c) { return '$' + (c / 100).toFixed(2); };
var num = function (v) { var n = parseFloat(String(v == null ? '' : v).replace(/[^0-9.]/g, '')); return isNaN(n) ? 0 : n; };
var norm = function (s) { return String(s == null ? '' : s).trim().replace(/\s+/g, ' ').toLowerCase(); };
var inch = function (n) { return n.toFixed(2) + '"'; };
var SIZE = /([0-9]+(?:\.[0-9]+)?)\s*(?:(?:"|[\u201c\u201d\u2033]|in(?:ches?)?)\s*)?(?:w(?:idth)?)?\s*[x\u00d7]\s*([0-9]+(?:\.[0-9]+)?)/i;
function init() {
var root = $('[data-cd]');
var form = root && root.closest('form');
if (!form) return;
var C = JSON.parse($('[data-cd-config]', root).textContent);
var E = C.endpoints;
var T = {}, box = document.createElement('textarea');
Object.keys(C.i18n).forEach(function (k) { box.innerHTML = C.i18n[k]; T[k] = box.value; });
var variants = JSON.parse($('[data-product-variants]').textContent);
var names = C.optionNames || [];
var sizeIdx = names.findIndex(function (n) { return /^sizes?:?$/.test(norm(n)); });
var B = { w0: num(C.minW), w1: num(C.maxW) || 9999, h0: num(C.minH), h1: num(C.maxH) || 9999 };
var minQty = Math.max(1, parseInt(C.minQty, 10) || 1);
var colorIdx = names.findIndex(function (n) { return /^colou?rs?:?$/.test(norm(n)); });
var colorMin = parseInt(C.colorMin, 10) || 0;
var exempt = (C.colorExempt || []).map(norm).filter(Boolean);
var sels = $$('[data-option-select]', form);
var idEl = $('[data-variant-id]', form);
var one = function (s) { return $(s, root); };
var cartQty = one('[data-cd-cart-qty]'), qIn = one('[data-cd-qty]'), drop = one('[data-cd-drop]');
var fileIn = one('[data-cd-file]'), art = one('[data-cd-art]'), img = one('[data-cd-img]');
var frame = one('[data-cd-frame]'), sizeStep = one('[data-cd-size]'), wIn = one('[data-cd-w]');
var hIn = one('[data-cd-h]'), lockBtn = one('[data-cd-lock]'), qual = one('[data-cd-quality]');
var confirmEl = one('[data-cd-confirm]'), tiersEl = one('[data-cd-tiers]'), nudge = one('[data-cd-tier-nudge]');
var busyEl = one('[data-cd-busy]'), barEl = one('[data-cd-bar]'), pctEl = one('[data-cd-pct]');
var msgEl = one('[data-cd-msg]'), stopBtn = one('[data-cd-stop]'), errEl = one('[data-cd-error]');
var unitEl = one('[data-cd-unit]'), dimW = one('[data-cd-dim-w]'), dimH = one('[data-cd-dim-h]');
var aiBtns = $$('[data-cd-ai]', root), shapes = $$('[data-cd-shape]', root);
var aiRow = aiBtns[0].parentNode, totalRow = one('[data-cd-total]').parentNode;
var moreEl = one('[data-cd-more]'), moreList = one('[data-cd-more-list]');
var moreIn = one('[data-cd-more-file]'), moreDrop = one('[data-cd-more-drop]');
var maxFiles = moreEl ? Math.max(1, parseInt(C.maxFiles, 10) || 1) : 1;
var rows = $$('[data-cd-tier]', root).map(function (b) {
return { b: b, min: +b.getAttribute('data-cd-tier'), next: +b.getAttribute('data-next'), pct: +b.getAttribute('data-pct') };
});
var A, S = { w: 0, h: 0, lock: true }, M = [], pass = false, shown = 0;
function fresh() { return { ops: [], cache: {}, dims: {} }; }
A = fresh();
function state() {
var vals = sels.map(function (s) { return s.value; });
var key = JSON.stringify(vals);
var sv = sizeIdx >= 0 ? vals[sizeIdx] : null;
var m = sv && String(sv).match(SIZE);
return {
vals: vals,
v: vals.length ? variants.find(function (x) { return JSON.stringify(x.options) === key; }) : variants[0],
fixed: m && +m[1] > 0 && +m[2] > 0 ? [+m[1], +m[2]] : null,
dyn: !!C.dynamic && (sv == null || norm(sv) === 'custom size')
};
}
function px() { return A.dims[A.url] || A.dims[A.local] || [0, 0]; }
function ratio() { var p = px(); return p[0] > 0 && p[1] > 0 ? p[0] / p[1] : 0; }
function needsSR(w, h) {
var p = px(), r = ratio();
if (!(w > 0 && h > 0) || !r) return true;
if (w / h > r) w = h * r; else h = w / r;
return w > p[0] / 300 + 0.01 || h > p[1] / 300 + 0.01;
}
function setWH(w, h, skip) {
if (S.lock && ratio() && w > 0 && h > 0) {
var lo = Math.max(B.w0 / w, B.h0 / h), hi = Math.min(B.w1 / w, B.h1 / h);
var s = lo > hi ? hi : Math.min(Math.max(1, lo), hi);
w *= s;
h *= s;
} else {
w = Math.min(B.w1, Math.max(Math.max(0.1, B.w0), w));
h = Math.min(B.h1, Math.max(Math.max(0.1, B.h0), h));
}
S.w = +w.toFixed(2);
S.h = +h.toFixed(2);
if (skip !== wIn) wIn.value = S.w.toFixed(2);
if (skip !== hIn) hIn.value = S.h.toFixed(2);
}
function onDim(el, commit) {
var isW = el === wIn, v = num(el.value), r = ratio();
if (v > 0) {
v = isW ? Math.min(B.w1, Math.max(Math.max(0.1, B.w0), v)) : Math.min(B.h1, Math.max(Math.max(0.1, B.h0), v));
if (S.lock && r) setWH(isW ? v : v * r, isW ? v / r : v, commit ? 0 : el);
else setWH(isW ? v : S.w, isW ? S.h : v, commit ? 0 : el);
} else if (commit) {
setWH(S.w, S.h);
}
paint();
}
function floor() {
var c = colorIdx >= 0 && sels[colorIdx] ? norm(sels[colorIdx].value) : '';
return colorMin > minQty && c && exempt.indexOf(c) < 0 ? colorMin : minQty;
}
function qty() { var f = floor(); return Math.max(f, parseInt(qIn.value, 10) || f); }
function setQ(n) {
qIn.value = cartQty.value = Math.max(floor(), n);
paint();
}
function applyFloor() {
var f = floor(), was = parseInt(qIn.min, 10) || minQty, note = one('[data-cd-color-min]');
var q = parseInt(qIn.value, 10) || 0;
qIn.min = f;
if (note) note.hidden = f <= minQty;
if (q < f || (f < was && q === was)) qIn.value = cartQty.value = f;
}
function paint() {
var st = state(), q = qty(), p = px();
var perSq = st.dyn && !(S.w > 0 && S.h > 0);
var ub = Math.round((st.v ? st.v.price : 0) * (st.dyn && !perSq ? Math.max(1, S.w * S.h) : 1));
var k = -1;
rows.forEach(function (r, i) { if (q >= r.min && (!r.next || q < r.next)) k = i; });
var unit = Math.round(ub * (100 - (k < 0 ? 0 : rows[k].pct)) / 100);
var per = perSq ? ' ' + T.perSqIn : '';
$$('[data-price]').forEach(function (el) {
el.textContent = money(unit);
var em = el.nextElementSibling;
if (em && em.tagName === 'EM') {
if (em._t == null) em._t = em.textContent;
em.textContent = perSq ? per : em._t;
}
});
unitEl.textContent = money(unit) + per;
totalRow.hidden = perSq;
$$('[data-cd-total]').forEach(function (el) {
el.textContent = perSq && !root.contains(el) ? money(unit) + per : money(unit * q);
});
tiersEl.hidden = !rows.length || perSq;
rows.forEach(function (r, i) {
r.b.setAttribute('aria-current', i === k);
r.b.parentNode.nextElementSibling.textContent = money(Math.round(ub * (100 - r.pct) / 100));
});
var nx = k >= 0 && rows[k + 1];
nudge.hidden = perSq || !nx;
if (nx) nudge.textContent = T.nudge.replace('%n', nx.min - q).replace('%p', nx.pct);
sizeStep.hidden = !(st.dyn && A.file);
var d = st.fixed || (st.dyn ? [S.w, S.h] : [p[0] / 300, p[1] / 300]);
dimW.textContent = inch(d[0]);
dimH.textContent = inch(d[1]);
var fr = st.fixed || (st.dyn && !S.lock && S.w > 0 && [S.w, S.h]);
frame.style.aspectRatio = fr ? fr[0] + '/' + fr[1] : '';
frame.style.width = fr ? 'min(100%,' + Math.round(240 * fr[0] / fr[1]) + 'px)' : '';
if (fr) frame.setAttribute('data-fit', ''); else frame.removeAttribute('data-fit');
var sel = st.fixed || (st.dyn && [S.w, S.h]);
var low = !!sel && needsSR(sel[0], sel[1]);
var msg = !A.file || !p[0] ? '' : !sel
? T.qualityStatic.replace('%w', inch(p[0] / 300)).replace('%h', inch(p[1] / 300))
: low ? T.qualityLow : T.qualityFixed.replace('%s', inch(sel[0]) + ' \u00d7 ' + inch(sel[1]));
if (qual.textContent !== msg) qual.textContent = msg;
qual.hidden = !msg;
if (low && msg) qual.setAttribute('data-tone', 'warn'); else qual.removeAttribute('data-tone');
aiBtns.forEach(function (b) {
var op = b.getAttribute('data-cd-ai'), on = A.ops.indexOf(op) >= 0;
b.setAttribute('aria-pressed', on);
b.setAttribute('aria-disabled', op === 'sr' && !on && !!sel && !low);
});
var n = C.stepStart;
$$('[data-cd-step]', root).forEach(function (s) { if (!s.hidden) $('.step__h i', s).textContent = ++n + '.'; });
}
function bar(v) {
shown = Math.max(shown, Math.round(v));
barEl.style.transform = 'scaleX(' + shown / 100 + ')';
pctEl.textContent = shown + '%';
}
function busy(m, at) {
A.busy = 1;
A.stopped = 0;
errEl.hidden = true;
if (at) at.after(busyEl); else root.appendChild(busyEl);
busyEl.hidden = pctEl.hidden = false;
busyEl.removeAttribute('data-spin');
msgEl.textContent = m;
shown = 0;
bar(0);
}
function spin(m) {
msgEl.textContent = m;
pctEl.hidden = true;
busyEl.setAttribute('data-spin', '');
}
function idle() {
A.busy = 0;
busyEl.hidden = true;
}
function fail(m, at, scroll) {
if (at) at.after(errEl); else root.appendChild(errEl);
errEl.textContent = m;
errEl.hidden = false;
if (scroll) errEl.scrollIntoView({ block: 'center' });
}
function show(src) {
img.onload = function () {
if (!A.dims[src]) A.dims[src] = [img.naturalWidth, img.naturalHeight];
if (src === A.local && !S.w) {
var p = px();
S.lock = true;
lockBtn.setAttribute('aria-pressed', true);
setWH(p[0] / 300, p[1] / 300);
}
paint();
};
img.onerror = function () { if (src === A.local) { reset(); fail(T.notImage, drop); } };
img.src = src;
}
function reset() {
if (A.local) URL.revokeObjectURL(A.local);
A = fresh();
S.w = S.h = 0;
fileIn.value = '';
img.removeAttribute('src');
art.hidden = true;
drop.hidden = false;
drop.setAttribute('data-s', 'rest');
list();
paint();
}
function pick(files) {
files = [].slice.call(files || []);
if (!files.length || A.busy) return;
if (A.file) return more(files);
var f = files.shift();
reset();
errEl.hidden = true;
A.file = f;
A.local = URL.createObjectURL(f);
one('[data-cd-name]').textContent = f.name;
drop.hidden = true;
art.hidden = false;
art.focus();
show(A.local);
more(files);
}
function more(files) {
var over = 0;
if (files.length) errEl.hidden = true;
files.forEach(function (f) {
if (M.length + 1 < maxFiles) M.push({ file: f, local: URL.createObjectURL(f) });
else over = 1;
});
list();
if (over && moreEl) fail(T.errMax, moreEl);
}
function drop1(m) {
URL.revokeObjectURL(m.local);
M.splice(M.indexOf(m), 1);
}
function list() {
if (!moreEl) return;
moreEl.hidden = !A.file;
moreDrop.hidden = M.length + 1 >= maxFiles;
moreList.textContent = '';
M.forEach(function (m) {
var li = document.createElement('li'), im = new Image(), s = document.createElement('span'), x = document.createElement('button');
im.alt = '';
im.width = im.height = 44;
im.onerror = function () { if (M.indexOf(m) >= 0) { drop1(m); list(); fail(T.notImage, moreEl); } };
im.src = m.local;
s.textContent = m.file.name;
x.type = 'button';
x.className = 'cd-more__x';
x.setAttribute('aria-label', T.removeMore.replace('%s', m.file.name));
x.textContent = '\u00d7';
x.addEventListener('click', function () { if (!A.busy) { drop1(m); errEl.hidden = true; list(); } });
li.append(im, s, x);
moreList.appendChild(li);
});
}
function post(url, body, tok, accept) {
var h = { 'Content-Type': 'application/json' };
if (tok) h.Authorization = 'Bearer ' + tok;
if (accept) h.Accept = 'application/json';
return fetch(url, { method: 'POST', headers: h, body: JSON.stringify(body) }).then(function (r) {
return r.json().catch(function () { return 0; }).then(function (d) {
d = d && typeof d === 'object' ? d : {};
d._s = r.status;
d._ok = r.ok;
return d;
});
});
}
function upload(at, of) {
if (A.orig) return Promise.resolve(A.orig);
return send(A.file, at || 0, of || 1).then(function (u) {
A.orig = u;
A.dims[u] = A.dims[A.local];
if (!A.ops.length) A.url = u;
return u;
});
}
function uploadAll() {
var todo = M.filter(function (m) { return !m.url; }), first = A.orig ? 0 : 1, of = todo.length + first;
return todo.reduce(function (p, m, i) {
return p.then(function () { return send(m.file, first + i, of); }).then(function (u) { m.url = u; });
}, upload(0, of));
}
function send(f, at, of) {
return post(E.init, { shop: C.shop, filename: f.name || 'upload', size: f.size || 0, mime: f.type || 'application/octet-stream' })
.then(function (t) {
if (!t._ok) throw 0;
return new Promise(function (ok, no) {
var x = A.xhr = new XMLHttpRequest(), fd = new FormData();
x.open('POST', t.upload_url || E.upload, true);
x.setRequestHeader('Authorization', 'Bearer ' + t.token);
x.upload.onprogress = function (e) { if (e.lengthComputable) bar(Math.min(95, (at + e.loaded / e.total) / of * 100)); };
x.onloadend = function () {
var d = 0;
A.xhr = null;
stopBtn.hidden = true;
try { d = JSON.parse(x.responseText); } catch (e) { d = 0; }
if (x.status >= 200 && x.status < 300 && d && d.url) ok(d.url); else no(A.stopped ? { stop: 1 } : 0);
};
fd.append('token', t.token);
fd.append('file', f);
stopBtn.hidden = false;
x.send(fd);
});
});
}
function ai(op, src) {
return post(E.aiInit, { shop: C.shop, scope: op === 'bg' ? 'removebg' : 'upscale' })
.then(function (t) {
if (!t._ok || !t.token) throw 0;
return post(E[op], { image_url: src, token: t.token }, t.token);
})
.then(function (d) {
if (!d._ok || !d.url) throw d._s === 429 && d.error === 'rate_limited' ? { busy: 1 } : 0;
var w = parseInt(d.width_px, 10), h = parseInt(d.height_px, 10);
if (op === 'bg') A.dims[d.url] = A.dims[src];
else if (w > 0 && h > 0) A.dims[d.url] = [w, h];
return d.url;
});
}
function build(ops) {
if (A.busy || !A.file) return;
if (!ops.length) {
A.ops = [];
A.url = A.orig;
show(A.local);
paint();
return;
}
var why = T.errUpload;
busy(T.uploading, aiRow);
upload().then(function (u) {
var i = 0;
return (function next(src) {
if (i === ops.length) return src;
var op = ops[i++], key = op + '|' + src;
if (A.cache[key]) return next(A.cache[key]);
why = op === 'bg' ? T.errBg : T.errSr;
spin(T[op]);
return ai(op, src).then(function (r) { A.cache[key] = r; return next(r); });
})(u);
}).then(function (u) {
idle();
A.ops = ops;
A.url = u;
show(u);
paint();
}, function (e) {
idle();
if (!(e && e.stop)) fail(e && e.busy ? T.busy : why, aiRow);
paint();
});
}
function prop(k, v) {
var n = 'properties[' + k + ']';
var el = [].find.call(form.elements, function (x) { return x.name === n; });
if (!el) {
el = document.createElement('input');
el.type = 'hidden';
el.name = n;
el.setAttribute('data-cd-prop', '');
form.appendChild(el);
}
el.value = v;
}
function ready(id, i) {
i = i || 0;
if (i > 5 || !/^\d+$/.test(id)) return Promise.reject(0);
return new Promise(function (ok) { setTimeout(ok, [0, 250, 500, 900, 1400, 2000][i]); })
.then(function () {
return fetch('/variants/' + id + '.js?cardinal_ready=' + Date.now(), { headers: { Accept: 'application/json' }, cache: 'no-store' });
})
.then(function (r) { return r.json(); })
.then(function (v) { return String(v.id) === id && v.available !== false; }, function () { return false; })
.then(function (ok) { return ok || ready(id, i + 1); });
}
function go() {
if (A.busy) return;
errEl.hidden = true;
var st = state(), q = qty();
var sh = $('[data-cd-shape][aria-pressed="true"]', root);
var why = !confirmEl.checked ? T.errConfirm
: !A.file ? T.errFile
: shapes.length && !sh ? T.errShape
: !st.v ? T.errVariant
: st.dyn && !(S.w > 0 && S.h > 0) ? T.errDims : '';
if (why) return fail(why, 0, 1);
why = T.errUpload;
var btns = $$('[type="submit"]', form).concat($$('[form="' + form.id + '"]'));
var hold = function (on) { btns.forEach(function (b) { b.disabled = on; }); };
hold(true);
busy(T.uploading);
uploadAll().then(function () {
$$('[data-cd-prop]', form).forEach(function (x) { x.remove(); });
idEl.value = st.v.id;
var d = st.fixed || (st.dyn && [S.w, S.h]);
if (st.dyn) prop('_cardinal_app', '1');
if (d) {
prop('Width (in)', d[0].toFixed(2));
prop('Height (in)', d[1].toFixed(2));
}
names.forEach(function (n, i) {
if (i !== sizeIdx && st.vals[i] != null) prop(String(n).trim().replace(/:\s*$/, ''), st.vals[i]);
});
cartQty.value = q;
if (!st.dyn && floor() > 1) prop('_min_qty', String(floor()));
if (sh) prop('Shape', sh.getAttribute('data-cd-shape').trim());
prop('Artwork URL', A.url);
M.forEach(function (m, i) { prop('Artwork URL ' + (i + 2), m.url); });
if (M.length) prop('Designs', String(M.length + 1));
if (!st.dyn) return;
why = T.errJob;
spin(T.job);
var src = variants.find(function (v) { return sizeIdx >= 0 && norm(v.options[sizeIdx]) === 'custom size'; }) ||
variants.find(function (v) { return v.id === C.initialVariant; }) || variants[0];
return post(E.pricing, {
source_product_id: String(C.productId),
source_variant_id: String(src.id),
width: S.w.toFixed(2),
height: S.h.toFixed(2),
print_quantity: q
}, 0, 1).then(function (r) {
if (!r._ok || !r.ok || !r.variant_id) throw { user: r.message };
var props = r.properties || {}, id = String(r.variant_id);
Object.keys(props).forEach(function (key) { prop(key, String(props[key] == null ? '' : props[key])); });
idEl.value = id;
cartQty.value = '1';
why = T.errPriceWait;
msgEl.textContent = T.price;
return ready(id);
});
}).then(function () {
idle();
hold(false);
pass = true;
form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
pass = false;
}, function (e) {
idle();
hold(false);
if (!(e && e.stop)) fail((e && e.user) || why, 0, 1);
});
}
fileIn.addEventListener('change', function () { pick(fileIn.files); });
['dragenter', 'dragover', 'dragleave', 'drop'].forEach(function (t) {
drop.addEventListener(t, function (e) {
e.preventDefault();
drop.setAttribute('data-s', t === 'dragenter' || t === 'dragover' ? 'drag' : 'rest');
if (t === 'drop') pick(e.dataTransfer.files);
});
});
one('[data-cd-remove]').addEventListener('click', function () {
if (A.busy) return;
var next = M[0];
if (next) { drop1(next); reset(); pick([next.file]); } else { reset(); fileIn.focus(); }
});
if (moreEl) {
moreIn.addEventListener('change', function () { if (!A.busy) more([].slice.call(moreIn.files)); moreIn.value = ''; });
['dragenter', 'dragover', 'dragleave', 'drop'].forEach(function (t) {
moreDrop.addEventListener(t, function (e) {
e.preventDefault();
moreDrop.setAttribute('data-s', t === 'dragenter' || t === 'dragover' ? 'drag' : 'rest');
if (t === 'drop' && !A.busy) more([].slice.call(e.dataTransfer.files));
});
});
}
stopBtn.addEventListener('click', function () { if (A.xhr) { A.stopped = 1; A.xhr.abort(); } });
aiBtns.forEach(function (b) {
b.addEventListener('click', function () {
var op = b.getAttribute('data-cd-ai'), on = A.ops.indexOf(op) < 0;
if (on && b.getAttribute('aria-disabled') === 'true') return;
build(on ? A.ops.concat(op) : A.ops.filter(function (x) { return x !== op; }));
});
});
[wIn, hIn].forEach(function (el) {
el.addEventListener('input', function () { onDim(el, false); });
el.addEventListener('change', function () { onDim(el, true); });
});
$$('[data-cd-nudge]', root).forEach(function (b) {
b.addEventListener('click', function () {
var el = b.getAttribute('data-cd-nudge') === 'w' ? wIn : hIn;
el.value = (num(el.value) + parseFloat(b.getAttribute('data-cd-by'))).toFixed(2);
onDim(el, true);
});
});
lockBtn.addEventListener('click', function () {
S.lock = !S.lock;
lockBtn.setAttribute('aria-pressed', S.lock);
setWH(S.w, S.lock && ratio() ? S.w / ratio() : S.h);
paint();
});
[wIn, hIn, qIn].forEach(function (el) {
el.addEventListener('keydown', function (e) {
if (e.key !== 'Enter') return;
e.preventDefault();
if (el === qIn) setQ(qty()); else onDim(el, true);
});
});
qIn.addEventListener('input', function () { cartQty.value = qty(); paint(); });
qIn.addEventListener('change', function () { setQ(qty()); });
$$('[data-cd-qty-by]', root).forEach(function (b) {
b.addEventListener('click', function () { setQ(qty() + parseInt(b.getAttribute('data-cd-qty-by'), 10)); });
});
rows.forEach(function (r) {
r.b.addEventListener('click', function () {
var q = qty();
if (!(q >= r.min && (!r.next || q < r.next))) setQ(r.min);
});
});
shapes.forEach(function (b) {
b.addEventListener('click', function () {
shapes.forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
});
});
form.addEventListener('change', function (e) {
if (e.target.hasAttribute('data-option-select')) { applyFloor(); paint(); }
});
document.addEventListener('submit', function (e) {
if (e.target !== form || pass) return;
e.preventDefault();
e.stopImmediatePropagation();
go();
}, true);
applyFloor();
paint();
window.DTFCardinal = true;
}
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', init);
} else {
init();
}
})();
